import { render, staticRenderFns } from "./EditCustomerView.vue?vue&type=template&id=57aaa4f0&scoped=true"
import script from "./EditCustomerView.vue?vue&type=script&lang=js"
export * from "./EditCustomerView.vue?vue&type=script&lang=js"
import style0 from "./EditCustomerView.vue?vue&type=style&index=0&id=57aaa4f0&prod&scoped=true&lang=scss"
import style1 from "./EditCustomerView.vue?vue&type=style&index=1&id=57aaa4f0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57aaa4f0",
  null
  
)

export default component.exports